export enum Condition {
  Warn = "Warn",
  // Error = "Error",
  // Success = "Success",
}

export enum EditorState {
  DATA = "DATA",
  EDITOR = "EDITOR",
  SETTINGS = "SETTINGS",
  LIBRARIES = "LIBRARIES",
}
